import { render, staticRenderFns } from "./searchBox.vue?vue&type=template&id=06c91ab0&scoped=true&"
import script from "./searchBox.vue?vue&type=script&lang=js&"
export * from "./searchBox.vue?vue&type=script&lang=js&"
import style0 from "./searchBox.vue?vue&type=style&index=0&id=06c91ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c91ab0",
  null
  
)

export default component.exports